export default "__VITE_ASSET__D6HuJMkZ__"